const convertObjectPropsToLowercase = (obj: { [key: string]: any }) =>
	Object.keys(obj).reduce((acc, k) => {
		acc[k.toLowerCase()] = obj[k];
		return acc;
	}, {} as { [key: string]: any });
export default convertObjectPropsToLowercase;
